import React from "react";

import {
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@material-ui/core";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";

export class MoveFilesModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFolder: false
        };
    }
    render() {
        const {
            files,
            folders,
            moveFilesModal,
            moveFiles,
            onSuccess,
            error,
            setModalView
        } = this.props;
        return (
            <Modal isOpen={moveFilesModal}>
                <ModalHeader>Move Files</ModalHeader>
                <ModalBody>
                    <ModalInfoText text=" Files to be moved:" />
                    {files &&
                        files.map(e => {
                            if (e.selected){
                                return (
                                    <Typography key={e.file_id}>
                                        {e.file_name}
                                    </Typography>
                                );
                            }
                            else return null;
                        })}
                    <FormControl>
                        <InputLabel htmlFor="age-simple">
                            Folder Name
                        </InputLabel>
                        <Select
                            style={{ minWidth: "200px" }}
                            value={this.state.selectedFolder}
                            onChange={event => {
                                this.setState({
                                    selectedFolder: event.target.value
                                });
                            }}
                            inputProps={{
                                name: "folder",
                                id: "folder-simple"
                            }}
                        >
                            {Object.keys(folders).map(e => {
                                return (
                                    <MenuItem value={e} key={e}>
                                        {folders[e]}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button
                        onClick={() => {
                            setModalView(false);
                        }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            moveFiles(
                                this.state.selectedFolder,
                                files,
                                success => {
                                    if (success) {
                                        onSuccess(true);
                                    } else {
                                        error(true);
                                    }
                                    setModalView(false);
                                }
                            );
                        }}
                        color="primary"
                        variant="contained"
                    >
                        Move File(s)
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
const ModalInfoText = props => {
    return (
        <Typography variant="subheading" style={{ marginBottom: 15 }}>
            {props.text}
        </Typography>
    );
};
